// POS-I186: the browser-tab title of the sign-in and register pages. index.html carries the same
// brand for a fresh load, so the old product name never shows.

export function authPageTitle(pathname: string): string {
  if (pathname.startsWith('/login')) return 'Sign in - ClearRing';
  if (pathname.startsWith('/register')) return 'Create your account - ClearRing';
  return 'ClearRing - Point of Sale';
}
